import { globalConstants } from "../constants";
import {
  getRequest,
  postRequest,
  getRequestWithParams,
  putRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

const instructorBaseUrl = "/admin/User/instructor/approved/";

const getAllInstructors = (data) => {
  return getRequestWithParams(
    `/${globalConstants.VERSION}${instructorBaseUrl}`,
    true,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInstructorById = (id) =>
  getRequest(`/${globalConstants.VERSION}${instructorBaseUrl}${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const getSpotInstructorById = (id) =>
  getRequest(
    `/${globalConstants.VERSION}/Instructor/center/instructor/${id}/`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
async function getApprovalRequestedInstructors(queryParams) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/admin/User/instructor/pending`,
    true,
    queryParams
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getApprovalRequestedInstructorById(id) {
  return getRequestWithParams(
    `/${globalConstants.VERSION}/admin/User/instructor/pending/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function approveInstructorDocuments(data) {
  return postRequest(
    `/${globalConstants.VERSION}/admin/Instructor/approval`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getInstructorsBySpotId(spotId, data) {
  return postRequest(
    `/${globalConstants.VERSION}/Instructor/spot/view/${spotId}`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const updateInstructorStatus = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/admin/Instructor/updateStatus`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const exportInstructorData = (gridState, requestType) => {
  return postRequest(
    `/${globalConstants.VERSION}/admin/User/export/instructor/${requestType}`,
    gridState
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInstructorsSports = (id) =>
  getRequest(`/${globalConstants.VERSION}/Instructor/sports/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const becomeFreelancePayment = (checkout) => {
  return postRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor`,
    checkout,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelMembership = (systemUserId) => {
  return putRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/cancel/${systemUserId}`,
    {},
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const becomeFreelanceRePayment = (checkout) => {
  return putRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/payment`,
    checkout,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const becomeFreelanceWithSavedCard = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/saveCard`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const becomeFreelanceWithSavedCardRepayment = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/savedCard/payment`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getFreelancerSportsDetail = (id) => {
  return getRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateFreelancerSportsDetail = (data) => {
  return putRequest(
    `/${globalConstants.VERSION}/FreelanceInstructor/update`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInstructorCenterDetail = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Instructor/center/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllCenterInstructors = (centerId) =>
  getRequest(
    `/${globalConstants.VERSION}/Instructor/center/instructors/${centerId}/`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const instructorService = {
  getAllInstructors,
  getInstructorById,
  updateInstructorStatus,
  getApprovalRequestedInstructors,
  getApprovalRequestedInstructorById,
  approveInstructorDocuments,
  exportInstructorData,
  getInstructorsBySpotId,
  getSpotInstructorById,
  getInstructorsSports,
  becomeFreelancePayment,
  becomeFreelanceWithSavedCard,
  getFreelancerSportsDetail,
  updateFreelancerSportsDetail,
  getInstructorCenterDetail,
  getAllCenterInstructors,
  becomeFreelanceRePayment,
  becomeFreelanceWithSavedCardRepayment,
  cancelMembership,
};
